import { slugify } from "@/helpers/format";

export const toEvents = (sport_type, query) => ({
  path: "/events",
  query: { ...query, sport_type: sport_type === "soccer" ? "football" : sport_type },
});

export const toEventsFromCity = (sport_type, query) => ({
  path: "/events",
  query: { ...query },
});

const isFormulaOneTournament = ({ sport_type, slug }) =>
  sport_type === "formula1" && /^formula-1(?:-\d{4})?$/.test(slug);

export const toTeam = ({ sport_type, slug }) =>
  toEvents(sport_type === "soccer" ? "football" : sport_type, { team: slugify(slug) });

export const toCity = ({ city }) => toEventsFromCity(city, { city: slugify(city) });

export const toTournament = ({ sport_type, slug }) =>
  isFormulaOneTournament({ sport_type, slug })
    ? toEvents(sport_type, {})
    : toEvents(sport_type, { tournament: slugify(slug) });

export const toVenue = ({ sport_type, slug }) => toEvents(sport_type, { venue: slug });
